import { SP } from "./namespace";
import {
  Particle,
  ROBES,
  SPRITE_BRIM,
  TAU,
  clamp,
  compact,
  lerp,
  makeWizardSprite,
  rand,
  rgba,
} from "../client";
SP._spriteCache = {};

SP.sprite = function(robeIdx) {
  const r = ROBES[robeIdx % ROBES.length];
  if (!SP._spriteCache[r.robe]) SP._spriteCache[r.robe] = makeWizardSprite(r.robe, r.trim);
  return SP._spriteCache[r.robe];
}

SP.glowOrb = function(c, r, col, ang, coreCol) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.save();
  c.rotate(ang);
  const tail = c.createLinearGradient(-r * 3.6, 0, r * 0.4, 0);
  tail.addColorStop(0, rgba(col, 0));
  tail.addColorStop(1, rgba(col, 0.6));
  c.fillStyle = tail;
  c.beginPath(); c.moveTo(0, -r * 0.75); c.lineTo(-r * 3.6, 0); c.lineTo(0, r * 0.75); c.closePath(); c.fill();
  c.restore();
  c.globalAlpha = 0.4; c.fillStyle = col;
  c.beginPath(); c.arc(0, 0, r * 1.8, 0, TAU); c.fill();
  c.globalAlpha = 0.85;
  c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
  c.restore();
  c.fillStyle = coreCol || "#ffffff"; c.globalAlpha = 0.95;
  c.beginPath(); c.arc(0, 0, r * 0.45, 0, TAU); c.fill();
  c.globalAlpha = 1;
}

SP.drawPlatform = function(c, cx, cy, r, t) {
  c.save();
  c.translate(cx, cy);
  const glow = 0.5 + 0.5 * Math.sin(t * 2);
  c.shadowColor = `rgba(255,90,40,${0.45 + 0.25 * glow})`;
  c.shadowBlur = 18 + 6 * glow;
  const g = c.createRadialGradient(0, -r * 0.2, r * 0.1, 0, 0, r);
  g.addColorStop(0, "#54506e");
  g.addColorStop(0.7, "#363250");
  g.addColorStop(1, "#211d38");
  c.fillStyle = g;
  c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
  c.shadowBlur = 0;
  c.lineWidth = 3;
  c.strokeStyle = `rgba(255,120,50,${0.65 + 0.3 * glow})`;
  c.beginPath(); c.arc(0, 0, r - 1, 0, TAU); c.stroke();
  c.restore();
}

SP.drawWizard = function(c, x, y, robeIdx, faceDir, bob, radius, castGlow) {
  const spr = SP.sprite(robeIdx);
  const ss = (radius / SPRITE_BRIM) * 1.12;
  c.save();
  c.translate(x, y + bob);
  c.fillStyle = "rgba(0,0,0,0.32)";
  c.beginPath(); c.ellipse(0, radius * 0.65, radius * 0.85, radius * 0.38, 0, 0, TAU); c.fill();
  c.scale(ss * faceDir, ss);
  c.drawImage(spr, -spr.width / 2, -spr.height / 2);
  c.restore();
  if (castGlow > 0) {
    c.save();
    c.translate(x + faceDir * radius * 0.95, y + bob - radius * 0.15);
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = castGlow * 0.85;
    c.fillStyle = "#ffd479";
    c.beginPath(); c.arc(0, 0, 4 + castGlow * 5, 0, TAU); c.fill();
    c.restore();
  }
}

SP.updateParticles = function(particles, dt) {
  for (const pt of particles) {
    pt.life -= dt;
    pt.vy += pt.grav * dt;
    pt.x += pt.vx * dt; pt.y += pt.vy * dt;
    const d = Math.pow(pt.drag, dt * 60);
    pt.vx *= d; pt.vy *= d;
  }
  compact(particles, p => p.life > 0);
}

SP.drawParticles = function(c, particles) {
  for (const pt of particles) {
    if (pt.glow) continue;
    const a = clamp(pt.life / pt.maxLife, 0, 1);
    c.globalAlpha = a * (pt.kind === "smoke" ? 0.45 : 0.9);
    c.fillStyle = pt.color;
    const grow = pt.kind === "smoke" ? pt.size * (1 + (1 - a) * 1.8) : pt.size * (0.4 + 0.6 * a);
    c.beginPath(); c.arc(pt.x, pt.y, grow, 0, TAU); c.fill();
  }
  c.globalCompositeOperation = "lighter";
  for (const pt of particles) {
    if (!pt.glow) continue;
    const a = clamp(pt.life / pt.maxLife, 0, 1);
    const r = pt.size * (0.5 + 0.7 * a);
    c.globalAlpha = a * 0.55;
    c.fillStyle = pt.color;
    c.beginPath(); c.arc(pt.x, pt.y, r * 1.6, 0, TAU); c.fill();
    c.globalAlpha = a;
    c.beginPath(); c.arc(pt.x, pt.y, r, 0, TAU); c.fill();
  }
  c.globalCompositeOperation = "source-over";
  c.globalAlpha = 1;
}

SP.drawShockwaves = function(c, waves) {
  c.save();
  c.globalCompositeOperation = "lighter";
  for (const w of waves) {
    const p = clamp(w.t / w.life, 0, 1);
    const r = lerp(w.r0, w.r1, 1 - (1 - p) * (1 - p));
    c.globalAlpha = (1 - p) * 0.65;
    c.strokeStyle = w.color;
    c.lineWidth = w.width * (1 - p * 0.55);
    c.beginPath(); c.arc(w.x, w.y, r, 0, TAU); c.stroke();
  }
  c.restore();
  c.globalAlpha = 1;
}

SP.hitVariant = function(spellId) {
  if (/freeze|frost|icelance|glacier|blizzard|frozen/i.test(spellId)) return "ice";
  if (/lightning|chain|reflect/i.test(spellId)) return "electric";
  if (/void|gravity|snare|disable|drain|link/i.test(spellId)) return "void";
  if (/fire|meteor|scourge|firespray|firewall/i.test(spellId)) return "fire";
  return "generic";
};

SP.spawnHit = function(sim, x, y, col, spellId) {
  const v = SP.hitVariant(spellId);
  const core = v === "ice" ? "#d6f6ff" : v === "electric" ? "#e8f4ff" : v === "void" ? "#c9a0ff" : "#ffd479";
  sim.shockwaves.push({ x, y, t: 0, life: 0.38, r0: 5, r1: 36, color: col, width: 3.2, glow: true });
  const n = v === "fire" ? 18 : 14;
  for (let i = 0; i < n; i++) {
    const a = rand(0, TAU), sp = rand(35, 150);
    sim.particles.push(new Particle(x, y, Math.cos(a) * sp, Math.sin(a) * sp,
      rand(0.16, 0.4), Math.random() < 0.5 ? core : col, rand(2, 6), { kind: "glow", grav: -28 }));
  }
  if (v === "fire") {
    for (let i = 0; i < 5; i++) {
      sim.particles.push(new Particle(x, y, rand(-22, 22), rand(-16, 8),
        rand(0.3, 0.6), "#2a201c", rand(3, 7), { kind: "smoke", grav: -32, drag: 0.9 }));
    }
  }
};

SP.loopStep = function(sim, cfg, t, dt) {
  const lt = t % cfg.loop;
  const prev = sim._prevLt != null ? sim._prevLt : lt;
  sim._prevLt = lt;
  if (lt < prev) {
    sim.particles = [];
    sim.shockwaves = [];
    sim.hitSpawned = false;
    sim.anim = {};
  }
  SP.updateParticles(sim.particles, dt);
  for (const w of sim.shockwaves) w.t += dt;
  return lt;
}
